// Taşeron portalı — Belge Analizi kalemi için geçerlilik tarihi ön-doldurması. C14'te
// (plan S25) eski `DocumentAnalysisItemCard.tsx`'ten TAŞINDI: dosya silindi, tek canlı
// tüketicisi (`AnalysisReviewPane.tsx`) artık buradan import ediyor.
import type { DocumentAnalysisItemDto, HazardClass } from '@isgportal/shared';

/**
 * FIX 5 (S24 UI-fix), GÜNCEL (S26 devamı — backend commit 4ec79f8) — `Geçerlilik
 * başlangıcı`/`Geçerlilik bitişi` ön-doldurma. Kural:
 *  - başlangıç ← kalemin `item.printedValidFrom`'u VARSA (tanıma sürümünün bu `(entity,
 *    code)` için bağladığı basılı başlangıç; analiz anında SAKLANIR, zaten yalnız
 *    `parse === 'ok'` iken doludur — bkz. `packages/shared/src/api/documentAnalyses.ts`).
 *  - bitiş ← kalemin `item.printedValidUntil`'i VARSA; YOKSA (yalnız
 *    doc-check yayınının İSG eğitim geçerlilik türetmesi bildirdiği türün kaleminde dolu;
 *    bugün (personnel, IsgTrainingCertificate), §20) `derived.isgEgitimValidUntil`'in tehlike
 *    sınıfına göre üç adayından (§13 `HazardClass` 1↔`azTehlikeli`/2↔`tehlikeli`/
 *    3↔`cokTehlikeli`, `packages/shared/src/api/documentAnalyses.ts` yorumu) TAŞERONUN
 *    GERÇEK sınıfına karşılık geleni. `hazardClass` bilinmiyorsa (sorgu henüz yüklenmedi)
 *    ÜÇ ADAYDAN BİRİNİ TAHMİN ETMEYİZ — boş bırakılır (yanlış bir tarihi "hesaplanmış" diye
 *    sunmak icat etmekle aynı şeydir).
 * Öncelik (basılıysa öncelik, yoksa hesapla) sunucunun DEĞİL, BU fonksiyonun kararıdır —
 * `printedValidFrom`/`printedValidUntil` sözleşmede bir sıralama DAYATMAZ.
 * Yalnız bir VARSAYILAN üretir — çağıran her iki alanı da normal `Input`lar üzerinden
 * DÜZENLENEBİLİR bırakır, kilitlemez.
 */
export function computeInitialValidity(
  item: DocumentAnalysisItemDto,
  hazardClass: HazardClass | null,
): { validFrom: string; validUntil: string; validUntilInferred: boolean } {
  const validFrom = item.printedValidFrom ?? '';

  if (item.printedValidUntil) {
    return { validFrom, validUntil: item.printedValidUntil, validUntilInferred: false };
  }

  const derived = item.derived.isgEgitimValidUntil;
  const derivedSourceOk = derived !== null && item.fields[derived.sourceField]?.parse === 'ok';
  if (derived && derivedSourceOk && hazardClass !== null) {
    const computed =
      hazardClass === 1
        ? derived.azTehlikeli
        : hazardClass === 2
          ? derived.tehlikeli
          : derived.cokTehlikeli;
    return { validFrom, validUntil: computed, validUntilInferred: true };
  }

  return { validFrom, validUntil: '', validUntilInferred: false };
}
